import { useEffect, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useMap } from "react-leaflet";
import { createLayerComponent } from "@react-leaflet/core"
import { decode_bbox } from "ngeohash";
import { flyOptions, getGeohashPrecision } from "../../../context/root/utils";
import { useRoot } from "../../../context/root";
import { useMap as useMapContext } from "../../../context/map";

export const useIcon = ({ data, isMobile }: { data: any, isMobile: boolean }) => {
  const navigator = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { mapRefresh, rootDispatch } = useRoot();
  const { mapContext } = useMapContext();
  const ref = useRef<any>();
  const position = data.data ? data.data.location.split(',') : data.coordinates;
  const { data: detailsData, geohash, coordinates } = data;
  const { geohash: geohashFromParam } = useParams();

  const handleClick = () => {
    if (!detailsData) {
      if (mapContext) {
        navigator({
          pathname: `${process.env.REACT_APP_INTERNAL_URL}bucket/${data.geohash}`,
          search: searchParams.toString()
        });
        const [minLat, minLng, maxLat, maxLng] = decode_bbox(geohash);
        rootDispatch({
          type: "setIsMapMoving",
          data: true
        })
        if (isMobile) {
          mapContext.flyTo(coordinates, getGeohashPrecision(geohash), { duration: 1 })
        }
        else {
          mapContext.flyToBounds([
            [minLat, maxLng],
            [maxLat, maxLng],
            [maxLat, minLng],
            [minLat, minLng]
          ], flyOptions);
        }
        mapContext.once("moveend", () => {
          rootDispatch({
            type: "setIsMapMoving",
            data: false
          })
          rootDispatch({
            type: "setDataList",
            data: []
          });
          rootDispatch({
            type: "setDataMarkers",
            data: []
          });
          rootDispatch({
            type: "setExtraMarker",
            data: null,
            mapContext
          });
          if (isMobile) {
            mapRefresh()
          }
          else {
            mapRefresh({ geohash })
          }
        })
      }
    }
    else {
      mapContext.flyTo(position, 12, { duration: 1 });
      if (isMobile) {
        if (ref.current) {
          rootDispatch({
            type: "setExtraMarker",
            data: {
              marker: ref.current,
              data: data.data
            },
            mapContext
          })
        }
      }
      else {
        if (geohashFromParam) {
          navigator({
            pathname: `${process.env.REACT_APP_INTERNAL_URL}bucket/${geohashFromParam}/details/${detailsData.id}`,
            search: searchParams.toString()
          });
        }
        else {
          navigator({
            pathname: `${process.env.REACT_APP_INTERNAL_URL}details/${detailsData.id}`,
            search: searchParams.toString()
          });
        }
      }
    }
  }

  useEffect(() => {
    if (ref && ref.current) {
      ref.current.addEventListener("click", handleClick);
    }
    return () => ref.current?.removeEventListener("click", handleClick);
  }, [ref])


  return {
    ref,
    position
  }
}